import React, { useContext } from 'react';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import AdminNav from '../admin/admin-nav';
import MemberNav from '../member/member-nav';
import './footer-style.css';

function Footer() {
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  return (
    <footer className="footer" role="contentInfo">
      {admin.auth.value && <AdminNav />}
      {member.auth.value && <MemberNav />}
    </footer>
  );
}

export default Footer;
